export const ROOM_KEY = 'ommri-care-admin.room';

/** Last room this browser called patients to (per-device convenience only). */
export function lastRoom(): string {
  try {
    return localStorage.getItem(ROOM_KEY) ?? '';
  } catch {
    return '';
  }
}

export function rememberRoom(room: string): void {
  try {
    localStorage.setItem(ROOM_KEY, room);
  } catch {
    // ignore
  }
}
